<template>
    <div class="page-etre">
        <raison-etre></raison-etre>
        <div class="etre-menu-mobile-box">
            <a href="#top" class="scrollTop" @click.prevent="goTo()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 55">
                    <polygon points="95 47.5 47.5 0 0 47.5 7.6 55 47.5 15.1 87.4 55 95 47.5"/>
                </svg>
            </a>
            <a href="#" class="etre-menu-mobile" @click.prevent="$root.$refs.etreAgir.fromEtreToAgir()">
                <span>the reasons behind our</span>
                <span>actions</span>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61"><path
                            d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                            style="fill: #006b58; stroke: rgb(11, 11, 11); stroke-miterlimit: 10;"></path>
                        <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                              style="fill: rgb(11, 11, 11);"></path>
                    </svg>
                </span>
            </a>
        </div>
        <a href="#" class="etre-menu" @click.prevent="$root.$refs.etreAgir.fromEtreToAgir()">
            <div class="etre-menu-box">
                <div class="agir-menu">
                    <span class="rotate"><span class="first">the reasons behind our</span> <span>actions</span></span>
                    <div class="etre-menu-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.49 22.14">
                            <path d="M10.28,21.81a1.12,1.12,0,1,0,1.59-1.57l-8-8H30.38a1.1,1.1,0,0,0,1.11-1.11A1.12,1.12,0,0,0,30.38,10H3.82l8-8a1.14,1.14,0,0,0,0-1.59,1.12,1.12,0,0,0-1.59,0l-9.95,10a1.11,1.11,0,0,0,0,1.58Z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>

    import anime from 'animejs';

    export default {
        name: 'Etre',
        mounted() {
            let timeline = anime.timeline({
                easing: 'easeInOutQuad',
                duration: 600,
            });

            document.querySelector('.etre-menu > div > div').style.transform = `translateY(110px) rotate(-90deg) translateY(55px)`

            timeline
                .add({
                    targets: document.querySelector('.etre-menu'),
                    translateX: ['100%', 0]
                })

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if (this.isInViewport(document.querySelector('.groupama-footer')) && document.querySelector('.etre-menu > div > div')) {
                    let height = document.querySelector('.groupama-footer').getBoundingClientRect().top - (window.innerHeight || document.documentElement.clientHeight)
                    document.querySelector('.etre-menu > div > div').style.transform =
                        `translateY(${110 + height}px) rotate(-90deg) translateY(55px)`
                } else if (document.querySelector('.etre-menu > div > div'))
                    document.querySelector('.etre-menu > div > div').style.transform = `translateY(110px) rotate(-90deg) translateY(55px)`
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + bounding.height
                );
            },
            goTo() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            },

        }
    }
</script>

<style scoped lang="scss">

    .page-etre {
        margin-top: 35vh;

        @media screen and (min-width: 2000px) {
            margin-top: 40vh;
        }
    }

    .agir-menu {
        opacity: .5;
        transition: .25s ease;
        transform: rotate(-90deg) translateY(25px);
        width: 500px;
        height: 220px;

        span.rotate {
            text-transform: uppercase;
            font-weight: 800;
            display: block;

            span {
                &:first-child {
                    color: #a1bf38;
                    position: absolute;
                    font-size: 25px;
                    line-height: 1;
                    transform: translate(22px, -10px);
                    width: 400px;
                }

                &:last-child {
                    color: #00352c;
                    font-size: 90px;
                    line-height: 1;
                }
            }

        }
    }

    .etre-menu {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        cursor: pointer;
        text-decoration: none;

        &-button {
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 0;
            width: 60px;
            height: 60px;
            border: 1px solid #00352c;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: translateX(-60px);
            svg {
                width: 30px;
                height: 30px;
                fill: #333333;
                transform: rotate(-90deg);
            }
        }

        &-mobile {
            &-box {
                display: none;
            }
        }

        &-box {
            height: 100vh;
            background: #006b58;
            display: flex;
            align-items: center;
            justify-content: center;
            position: sticky;
            top: 0;
            width: 220px;
            border-left: 1px solid #00352c;
        }


        &:hover, &:focus {

            .agir-menu {
                opacity: 1;
            }

            .etre-menu-button {
                background: #00352c;
                svg {
                    fill: #a1bf38;
                }
            }


        }

    }

    @media screen and (max-width: 1400px) {
        .agir-menu {
            height: 150px;
        }

        .agir-menu span.rotate span:first-child {
            transform: translate(18px, -15px);
            font-size: 22px;
        }

        .agir-menu span.rotate span:last-child {
            font-size: 70px;
        }

        .etre-menu-button {
            transform: translateX(-70px);
        }
    }

    @media screen and (max-width: 780px) {
        .page-etre {
            .etre-menu {
                display: none;

                &-mobile {
                    &-box {
                        background: #006b58;
                        z-index: 99;
                        width: 100%;
                        position: relative;
                        display: block;
                        border-top: 1px solid #00352c;
                        padding-top: 34px;
                        padding-bottom: 34px;
                    }

                    display: flex;
                    flex-direction: column;
                    text-decoration: none;
                    margin-right: 30px;
                    margin-left: auto;
                    align-items: flex-end;

                    span {
                        position: relative;

                        &:nth-child(1) {
                            position: absolute;
                            right: 80px;
                            color: #004135;
                            font-size: 12px;
                            text-transform: uppercase;
                            font-weight: 700;
                            transform: translateY(2px);
                        }

                        &:nth-child(2) {
                            color: #a1bf38;
                            text-transform: uppercase;
                            font-weight: 900;
                            font-size: 80px;
                            opacity: .5;
                        }

                        &:nth-child(3) {
                            width: 36px;
                            height: 36px;
                            margin-top: -20px;

                            svg {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                }

            }

        }

        .scrollTop {
            position: absolute;
            left: 25px;
            bottom: 30px;
            background: #004135;
            border-radius: 50%;
            width: 52px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: auto;

            svg {
                fill: white;
                width: 19px;
                height: 11px;
            }
        }
    }

</style>
